import { Reveal } from "./motion/Reveal";

const DOT_COLORS = ["bg-dot-red", "bg-dot-amber", "bg-dot-green", "bg-dot-blue", "bg-navy", "bg-dot-red"];

export default function Timeline({ steps }) {
  return (
    <div data-testid="journey-timeline">
      <div className="hidden lg:block">
        <div className="relative grid grid-cols-6 gap-6">
          <div className="absolute left-0 right-0 top-[22px] h-px bg-slate-200" aria-hidden="true" />
          {steps.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.1}>
              <div className="relative">
                <span className={`relative z-10 flex h-11 w-11 items-center justify-center rounded-full border-4 border-ivory font-mono-accent text-[11px] font-bold text-white ${DOT_COLORS[i % DOT_COLORS.length]}`}>
                  {s.step}
                </span>
                <h3 className="mt-5 font-display text-lg font-semibold text-navy-dark">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <div className="relative space-y-8 lg:hidden">
        <div className="absolute bottom-2 left-[21px] top-2 w-px bg-slate-200" aria-hidden="true" />
        {steps.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.06}>
            <div className="relative flex gap-5">
              <span className={`relative z-10 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-4 border-ivory font-mono-accent text-[11px] font-bold text-white ${DOT_COLORS[i % DOT_COLORS.length]}`}>
                {s.step}
              </span>
              <div>
                <h3 className="font-display text-lg font-semibold text-navy-dark">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{s.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
